<template>
  <div id="app">
    <link rel="preconnect" href="https://fonts.gstatic.com">
    <link href="https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap" rel="stylesheet">

    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
    </div> -->
    <router-view/>
  </div>
</template>

<script>
  /* 追加 */
  export default {
    mounted(){
      var routeInstance = this.$route;
      this.setMeta(routeInstance);
    },
    methods : {
      setMeta (to) {
        if(to.meta.title){
          document.title = to.meta.title;
        }
        if(to.meta.desc){
          document.querySelector("meta[name='viewport']").setAttribute('content', to.meta.viewport)
        }
      }
    },
    watch: {
      '$route' (to) {
        this.setMeta(to);
      }
    }
  }
</script>

<style lang="scss">

</style>
